/** @format */

import {Input} from '@sttark/design-system';
import {forwardRef} from 'react';

export const TextArea = forwardRef((props, ref) => (
    <Input ref={ref} rows={props.rows || 4} {...props} />
));

TextArea.displayName = 'TextArea';

TextArea.propTypes = Input.propTypes;

TextArea.defaultProps = {
    rows: 4,
    label: 'Label Name'
};
